import React from 'react'
import PropTypes from 'prop-types'
import { complement } from 'ramda'
import EducationProfileEvents from './EducationProfileEvents'

EducationProfileMatch.propTypes = {
  children: PropTypes.node.isRequired,
  withEvents: PropTypes.arrayOf(PropTypes.string),
  withSomeEvents: PropTypes.arrayOf(PropTypes.string),
  withoutEvents: PropTypes.arrayOf(PropTypes.string)
}

export default function EducationProfileMatch({
  children,
  withEvents,
  withSomeEvents,
  withoutEvents
}) {
  return (
    <EducationProfileEvents>
      {events => match(events, withEvents, withSomeEvents, withoutEvents) && children}
    </EducationProfileEvents>
  )
}

function match(events, withEvents, withSomeEvents, withoutEvents) {
  const eventTypes = events.map(event => event.eventType)
  const inEvents = eventTypes.includes.bind(eventTypes)
  const withEventsCheck = withEvents ? withEvents.every(inEvents) : true
  const withSomeEventsCheck = withSomeEvents ? withSomeEvents.some(inEvents) : true
  const withoutEventsCheck = withoutEvents ? withoutEvents.every(complement(inEvents)) : true
  return withEventsCheck && withSomeEventsCheck && withoutEventsCheck
}
